"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledPopup = exports.StyledCancelButton = exports.StyledButton = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Button2 = require("../../../Button/Button");
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _SuccessIcon = _interopRequireDefault(require("../../../SuccessIcon"));
var _iconsReact = require("../../../../icons-react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TYPES = {
  FAILURE: 'failure',
  SUCCESS: 'success',
  WARNING: 'warning'
};
var DEFAULT_SUBMIT = 'Продолжить';
var ActionPopup = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var isOpen = _ref.isOpen,
    title = _ref.title,
    type = _ref.type,
    submitText = _ref.submitText,
    description = _ref.description,
    onCancel = _ref.onCancel,
    onSubmit = _ref.onSubmit,
    className = _ref.className;
  var handleCancel = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    event.preventDefault();
    onCancel();
  }, [onCancel]);
  var handleSubmit = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    event.preventDefault();
    onSubmit();
  }, [onSubmit]);
  return /*#__PURE__*/_react["default"].createElement(StyledPopup, {
    isOpen: isOpen
  }, /*#__PURE__*/_react["default"].createElement(StyledForm, {
    className: className,
    onSubmit: handleSubmit
  }, type === TYPES.WARNING ? /*#__PURE__*/_react["default"].createElement(_iconsReact.Attention, {
    width: 60
  }) : /*#__PURE__*/_react["default"].createElement(_SuccessIcon["default"], {
    success: type === TYPES.SUCCESS
  }), title && /*#__PURE__*/_react["default"].createElement(StyledTitle, null, title), description && /*#__PURE__*/_react["default"].createElement(StyledDescription, null, description), /*#__PURE__*/_react["default"].createElement(StyledControls, null, /*#__PURE__*/_react["default"].createElement(StyledButton, {
    type: _Button2.Types.SUBMIT
  }, submitText), /*#__PURE__*/_react["default"].createElement(StyledCancelButton, {
    onClick: handleCancel
  }, "\u041E\u0442\u043C\u0435\u043D\u0430"))));
});
ActionPopup.displayName = 'ActionPopup';
ActionPopup.propTypes = {
  className: _propTypes["default"].string,
  description: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  submitText: _propTypes["default"].string,
  title: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(Object.values(TYPES))
};
ActionPopup.defaultProps = {
  className: '',
  description: null,
  submitText: DEFAULT_SUBMIT,
  title: null,
  type: TYPES.FAILURE
};
var StyledPopup = exports.StyledPopup = (0, _styledComponents["default"])(_Modal["default"]).withConfig({
  displayName: "ActionPopup__StyledPopup",
  componentId: "sc-1h9xkkt-0"
})(["display:", ";align-items:center;justify-content:center;"], function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 'flex' : 'none';
});
var StyledForm = _styledComponents["default"].form.withConfig({
  displayName: "ActionPopup__StyledForm",
  componentId: "sc-1h9xkkt-1"
})(["display:flex;align-items:center;flex-direction:column;padding:40px 10px 10px 10px;background:white;border-radius:6px;width:416px;"]);
var StyledTitle = _styledComponents["default"].p.withConfig({
  displayName: "ActionPopup__StyledTitle",
  componentId: "sc-1h9xkkt-2"
})(["font-size:18px;font-weight:bold;line-height:22px;color:#17181a;margin-bottom:10px;margin-top:30px;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "ActionPopup__StyledDescription",
  componentId: "sc-1h9xkkt-3"
})(["width:250px;margin-bottom:25px;font-family:'Backpack',sans-serif;font-size:14px;line-height:17px;text-align:center;"]);
var StyledControls = _styledComponents["default"].div.withConfig({
  displayName: "ActionPopup__StyledControls",
  componentId: "sc-1h9xkkt-4"
})(["display:flex;width:100%;"]);
var StyledButton = exports.StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ActionPopup__StyledButton",
  componentId: "sc-1h9xkkt-5"
})(["width:50%;border-radius:4px;color:white;background-color:#007aff;font-size:14px;height:42px;line-height:24px;min-height:25px;min-width:25px;padding:0;position:relative;text-align:center;"]);
var StyledCancelButton = exports.StyledCancelButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ActionPopup__StyledCancelButton",
  componentId: "sc-1h9xkkt-6"
})(["border:none;width:50%;border-radius:4px;color:#4d4d4d;background-color:transparent;font-weight:normal;font-size:14px;height:42px;line-height:24px;min-height:25px;min-width:25px;padding:0;position:relative;text-align:center;"]);
ActionPopup.TYPES = TYPES;
var _default = exports["default"] = ActionPopup;